import defaults from 'lodash/defaults';

// never use import.meta.env variables directly from the code, but use these exports
// so for other apps like news-connect it can be overriden by injecting an object to the window
// prior (or after) app loading

// collect all defaults from import.meta.env
const env = import.meta.env;
export const VITE_ALWAYS_HTTPS = env.VITE_ALWAYS_HTTPS as string;
export const VITE_AUTH_API_HOST = env.VITE_AUTH_API_HOST as string;
export const VITE_LOGIN_PAGE_URL = env.VITE_LOGIN_PAGE_URL as string;
export const VITE_PLATFORM_UUID = env.VITE_PLATFORM_UUID as string;
export const VITE_OAUTH_GOOGLE = env.VITE_OAUTH_GOOGLE as string;
export const VITE_OAUTH_FACEBOOK = env.VITE_OAUTH_FACEBOOK as string;
export const VITE_REFERRAL_URL = env.VITE_REFERRAL_URL as string;

// extend Window object and ensure PP_APP_CONFIG object exists on it with default values from import.meta.env
declare global {
  interface Window {
    PP_APP_CONFIG: {
      VITE_ALWAYS_HTTPS: boolean;
      VITE_AUTH_API_HOST: string;
      VITE_LOGIN_PAGE_URL: string;
      VITE_PLATFORM_UUID: string;
      VITE_OAUTH_GOOGLE: string | null; // null in non-pp apps
      VITE_OAUTH_FACEBOOK: string | null; // null in non-pp apps
      VITE_REFERRAL_URL: string | null; // null in non-pp apps
    };
  }
}

window.PP_APP_CONFIG = defaults(window.PP_APP_CONFIG, {
  VITE_ALWAYS_HTTPS: typeof VITE_ALWAYS_HTTPS === 'string' ? /true/i.test(VITE_ALWAYS_HTTPS) : true,
  VITE_AUTH_API_HOST,
  VITE_LOGIN_PAGE_URL,
  VITE_PLATFORM_UUID,
  VITE_OAUTH_GOOGLE,
  VITE_OAUTH_FACEBOOK,
  VITE_REFERRAL_URL,
});

// NOTE: use functions to access window.PP_APP_CONFIG in case it changes after this file is executed
export const getConfigAlwaysHttps = () => window.PP_APP_CONFIG.VITE_ALWAYS_HTTPS;
export const getPureprofileGatewayUrl = () => window.PP_APP_CONFIG.VITE_LOGIN_PAGE_URL;
export const getConfigPlatformUuid = () => window.PP_APP_CONFIG.VITE_PLATFORM_UUID;
export const getConfigOauthGoogle = () => window.PP_APP_CONFIG.VITE_OAUTH_GOOGLE;
export const getConfigOauthFacebook = () => window.PP_APP_CONFIG.VITE_OAUTH_FACEBOOK;
export const getConfigReferralUrl = () => window.PP_APP_CONFIG.VITE_REFERRAL_URL;
